
import { ReactComponent as Check } from './share-check.svg'
import { ReactComponent as CheckIn } from './checkIn.svg'
import { ReactComponent as Mail } from './share-mail.svg'
import { ReactComponent as   Facebook } from './facebook.svg'
import { ReactComponent as Instagram } from './instagram.svg'
import { ReactComponent as TwitterX } from './twitterx.svg'


export const Icons = {
  Check,
  CheckIn,
  Mail,
  Facebook,
  Instagram,
  TwitterX
}